<template>
	<div>
		<div class="page-title">
			<icon-font class="title-icon" type="icon-xiazaizhongxin" style="margin-right: 12px"/>
			<span>下载中心</span>
		</div>
		<div class="page-filter" v-if="filterVisible">
			<a-form-model ref="form" :model="params">
				<a-form-model-item label="所属模块" prop="module">
					<a-input v-model.trim="params.module" placeholder="请输入查询条件"></a-input>
				</a-form-model-item>
				<a-form-model-item label="文件名称" prop="fileName">
					<a-input v-model.trim="params.fileName" placeholder="请输入查询条件"></a-input>
				</a-form-model-item>
				<a-form-model-item label="文件状态" prop="status">
					<a-select v-model.trim="params.status" placeholder="请输入查询条件">
						<a-select-option :value="key" v-for="(val, key) in $enum.FILE_STATUS" :key="key">{{val.text}}</a-select-option>
					</a-select>
				</a-form-model-item>
				<div class="handle-btn">
					<a-button type="primary" @click="search">查询</a-button>
					<a-button @click="reset">重置</a-button>
				</div>
			</a-form-model>
		</div>
		<div class="page-table">
      <vxe-grid
        border="inner"
        :columns="columns"
        auto-resize
        :column-config="{resizable: true}"
        :row-config="{isCurrent: true, isHover: true}"
        :data="data"
        show-overflow
        :empty-render="{name: 'NotData'}"
        size="small"
        :loading="loading"
			>
				<template #status="{row}">
					<div :class="statusEnum(row.status).class">{{statusEnum(row.status).text}}</div>
				</template>
				<template  #handle="{row}" >
					<div class="table-handle-btn">
						<span  v-if="row.status !== 15">-</span>
            <a-tooltip placement="top" title="下载" v-else>
							<icon-font @click="downloadClick(row)" class="view-btn" type="icon-Download"/>
						</a-tooltip>
					</div>
				</template>
			</vxe-grid>
      <a-pagination
        class="mt-16 mb-16 df-end"
        size="small"
        v-if="(data &&data.length > 0)"
        :pageSize="pagination.pageSize"
        :total="pagination.total"
        :current="pagination.current"
        @change="(page, pageSize) => handleTableChange(page,pageSize)"
      />
		</div>
	</div>
</template>
<script>
import { getFileList, downloadFile } from '@/api/mediadata'

const columns = [
	{
		title: '所属模块',
		field: 'module',
		align: 'center',
		width: 135,
	},
	{
		title: '文件名称',
		field: 'fileName',
		// width: 260,
    ellipsis: true,
		align: 'left',
	},
	{
		title: '文件状态',
		field: 'status',
    slots: { default: 'status' },
		align: 'center',
		width: 151,
	},
	{
		title: '创建人',
		field: 'creator',
		align: 'left',
		// width: 180,
	},
	{
		title: '最后操作时间',
		field: 'createTime',
		align: 'left',
		// width: 180,
	},
  {
		title: '操作',
		field: 'handle',
		align: 'left',
		slots: { default: 'handle' },
		width: 100,
	},
]
export default {
	name: 'UserDefinedModel',
	data() {
		return {
			loading: false,
			params: {
				module: '',
				fileName: '',
				status: undefined
			},
			pagination: {
				current: 1,
				total: 0,
				pageSize: 10,
        showTotal: total => `共${total}条`
			},
			filterVisible: false,
			data: [],
			columns
		}
	},
	methods: {
		reset() {
			this.$refs.form.resetFields()
			this.pagination.current = 1
			this.getList()
		},
		search() {
			console.log(this.params)
			this.pagination.current = 1
			this.getList()
		},
		statusEnum(text) {
			let obj = this.$enum.FILE_STATUS[text] || { class: "", text: "" }
			return obj
		},
		// 下载
		async downloadClick(record) {
			if(record.status !== 15) return;
			const file = await downloadFile(record.id)
			const FileName = record.fileName;
			this.$CreatDownload(file, FileName)
		},
		getList() {
      this.loading = true
      getFileList({
        pageSize: this.pagination.pageSize,
        pageNo: this.pagination.current,
        ...this.params
      }).then((res) => {
        this.data = res.data.recordList || []
        this.pagination.total = res.data.recordCount
      }).finally(() => this.loading = false)
    },
		handleTableChange(pagination) {
			const pager = { ...this.pagination };
			pager.current = pagination;
			this.pagination = pager;
      this.getList()
		},
	},
	mounted() {
		this.getList()
	},
	components: {
	}
}
</script>
<style lang="less" scoped>
	.page-filter {
		margin: 12px 24px 16px 24px;
  	padding: 14px 16px 0 16px;
  	background: #FBFCFF;
  	border-radius: 8px;
		/deep/ .ant-form-item {
			display: inline-block;
			margin-right: 16px;
		}
		/deep/ .ant-input, /deep/.ant-select {
			width: 258px;
		}
		.handle-btn {
			margin-top: 40px;
			float: right;
			.ant-btn {
				margin-left: 12px;
			}
		}
	}
	.view-btn {
		margin-right: 16px;
	}
	.view-btn,.copy-btn, .edit-btn {
		cursor: pointer;
		font-size: 16px;
		vertical-align: middle;
	}
	.waiting {
		line-height: 22px;
		background: #FEFBF0;
		border-radius: 4px;
		font-size: 12px;
		color: #E67A00;
		padding: 0 8px;
		display: inline-block;
	}
	.preparation {
		line-height: 22px;
		background: #FEFBF0;
		border-radius: 4px;
		font-size: 12px;
		color: #E67A00;
		padding: 0 8px;
		display: inline-block;
	}
	.success {
		line-height: 22px;
		background: #F2FAF3;
		border-radius: 4px;
		font-size: 12px;
		color: #22AC35;
		padding: 0 8px;
		display: inline-block;
	}
	.failure {
		line-height: 22px;
		background: #FDF4F4;
		border-radius: 4px;
		font-size: 12px;
		color: #E6494F;
		padding: 0 8px;
		display: inline-block;
	}
	.disabled {
		cursor: not-allowed;
	}
</style>